import React from "react";

export const Empty_Container = ({ randomColor }) => {
  // onEmptyCircles function checks for which particular circle with that id is clicked and returns it respective styles

  const onEmptyCircles = (e) => {
    let val = e.target.id;
    document.getElementById(`${val}`).style.height = "0px";
    document.getElementById(`${val}`).style.width = "0px";
    var new_circle = val.replace("empty-", "");
    document.getElementById(`${new_circle}`).style.height = "100px";
    document.getElementById(`${new_circle}`).style.width = "100px";
    setTimeout(() => (document.getElementById(`${new_circle}`).style.display = "block"), 400) 
  };
  return (
    <div className="empty-circles-container">
      <p className="text-center">Empty Div</p>
      <div className="empty-circles" onClick={(e) => onEmptyCircles(e)}>
        <div
          className="circle"
          id="empty-circle-1"
          style={{ backgroundColor: randomColor[0] }}
        >1</div>
        <div
          className="circle"
          id="empty-circle-2"
          style={{ backgroundColor: randomColor[1] }}
        >2</div>
        <div
          className="circle"
          id="empty-circle-3"
          style={{ backgroundColor: randomColor[2] }}
        >3</div>
        <div
          className="circle"
          id="empty-circle-4"
          style={{ backgroundColor: randomColor[3] }}
        >4</div>
        <div
          className="circle"
          id="empty-circle-5"
          style={{ backgroundColor: randomColor[4] }}
        >5</div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Components/Empty-Container.jsx